const getProductById = state => (productId) => {
  if (state.products) {
    return state.products.find(p => p.id === productId);
  }
};

const getProductByProductId = state => (productId) => {
  if (state.products) {
    return state.products.find(p => p.productId === productId);
  }
};

const getAvailableInsureSignAgencyUsers = state => {
  return state.agencyUsers.filter((x) => state.insureSignUsers.findIndex((y) => y.initials === x.initials) < 0);
};

const getPendingSeatManagementRequestById = state => (id) => {
  return state.seatManagementPendingRequests.find(x => x.id === id);
};

const getVisibleRemoteAgencySeats = state => {
  return state.remoteAgencySeats.filter(function (seat) { return seat.display === true; });
};

const isSeatManagementEnabled = state => {
  if (state.featureSwitches === null) {
    return false;
  }
  return state.featureSwitches['SeatManagement'];
};

const getAgency = (state) => {
  return state.agency;
};

const getAgencyVersion = state => {
  return state.agencyVersion;
};

const hasVersion5 = state => {
  return state.hasVersion5;
};

const getTextingSetupOrderStatus = state => {
  return state.textingSetup.orderStatus;
};

export default {
  getProductById,
  getAvailableInsureSignAgencyUsers,
  getProductByProductId,
  getPendingSeatManagementRequestById,
  getVisibleRemoteAgencySeats,
  isSeatManagementEnabled,
  getAgencyVersion,
  hasVersion5,
  getAgency,
  getTextingSetupOrderStatus
};
